// AI Tool Set - Base class for grouping AI tool functions
// Subclass this to define tool sets for specific models or groups of models
// More flexible than BaseTool - can define multiple tools, multiple models, or one tool for one model
// Each tool registration specifies which models it applies to

import { BASE_AI_TOOL_UI_STYLE_BUNDLE } from "./baseAIToolUiStyleBundle.js";

export class AIToolSet {
  constructor() {
    this.aiToolSystem = null; // Set by AIToolSystem when tool set is registered
    // Note: workspaceToolSystem is not set here - WorkspaceAIToolSet provides a getter for it
  }

  /**
   * Register tools for this tool set
   * Override this method in subclasses to register tools
   * Each tool registration specifies which models it applies to
   * Access the AI tool system via this.aiToolSystem
   */
  registerTools() {
    // Override in subclasses
    // Example:
    // this.aiToolSystem.registerTool(
    //   "read_file",
    //   { type: "function", function: { name: "read_file", ... } },
    //   this.readFileHandler.bind(this),
    //   null  // null = all models, or ["model1", "model2"] for specific models
    // );
  }

  registerTool(ToolClass, modelIds = null) {
    if (!this.aiToolSystem?.registerTool) {
      throw new Error("AI tool system is not available");
    }
    this.aiToolSystem.registerTool(ToolClass, modelIds, this);
  }

  /**
   * Optional style bundles for tool-authored HTML used by this tool set.
   * Surfaces that render tool bubbles should mount these bundles through
   * the generic AIToolUiStyleHost rather than importing tool CSS directly
   * into ChatBubble or other shared bubble shell components.
   */
  getToolUiStyleBundles() {
    return [BASE_AI_TOOL_UI_STYLE_BUNDLE];
  }

  hasCheckpointEntry(entryId, responseMessageId = null) {
    return (
      this.aiToolSystem?.hasCheckpointEntry?.(entryId, responseMessageId) ||
      false
    );
  }

  createCheckpointEntry(entryId, entry, responseMessageId = null) {
    return (
      this.aiToolSystem?.createCheckpointEntry?.(
        entryId,
        entry,
        responseMessageId
      ) || false
    );
  }

  createRedoCheckpointEntry(entryId, entry) {
    return (
      this.aiToolSystem?.createRedoCheckpointEntry?.(entryId, entry) || false
    );
  }

}
